import { useSelector } from 'react-redux';

import { IApplicationState } from '../../../../common/types/redux';
import { selectMapBounds } from '../../../selectors';
import { TMapBounds } from '../../../types/mapBounds';

/**
 * Зум карты для расчётов: после updateBounds-запроса mapBounds в сторе «сырой» —
 * bboxToMapBounds кладёт только bounds, без zoom (тип TMapBounds этого не отражает),
 * поэтому фоллбек на фактический зум карты.
 *
 * Фоллбек не реактивен (map.getZoom() не триггерит ререндер), но окно «сырого»
 * состояния самозакрывается ближайшим boundschange, который кладёт полный zoom.
 */
export function useMapZoom(map: YMaps.Map): number {
  const { zoom } = useSelector<IApplicationState, TMapBounds>(selectMapBounds);

  return zoom ?? map.getZoom();
}
